module.exports = __webpack_public_path__ + "static/media/give.bed1057e.png";